// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChatWindow.css
// module id = 1156
// module chunks = 0